const S3 = "https://soulsync-videos.s3.ap-south-1.amazonaws.com";

export const BG_VIDEOS = {
  bg1: `${S3}/bg1-small.mp4`,
  bg2: `${S3}/bg2-small.mp4`,
  bg3: `${S3}/bg3-small.mp4`,
  bg4: `${S3}/bg4-small.mp4`,
};
